export const TypesDesova = {
    SET_PASSAGEM_ID: 'desova/SET_PASSAGEM_ID',
    SET_LOTE_ID: 'desova/SET_LOTE_ID',
    SET_LISTA_LOTES: 'desova/SET_LISTA_LOTES',
    SET_VOLUME: 'desova/SET_VOLUME',
    SET_VOLUME_SEM_RECONHECIMENTO: 'desova/SET_VOLUME_SEM_RECONHECIMENTO',
    SET_RECONHECIMENTO: 'desova/SET_RECONHECIMENTO',
    SET_LOTE_ALTERACAO: 'desova/SET_LOTE_ALTERACAO',
    SET_CONTAINER: 'desova/SET_CONTAINER',
    SET_BL_ID: 'desova/SET_BL_ID',
    SET_MOTIVO_INTERRUPCAO: 'desova/SET_MOTIVO_INTERRUPCAO',
    SET_TITLE: 'desova/SET_TITLE',
    SET_TITLE_DESCRIPTION: 'desova/SET_TITLE_DESCRIPTION',
    SET_LACRE: 'desova/SET_LACRE',
    SET_EMPILHADEIRAS: 'desova/SET_EMPILHADEIRAS',
    SET_EMBALAGENS: 'desova/SET_EMBALAGENS',
    SET_LOCALIDADES: 'desova/SET_LOCALIDADES',
    SET_DESOVA: 'desova/SET_DESOVA',
    SET_ACRESCIMO: 'desova/SET_ACRESCIMO',
    SET_DETALHES_VOLUME: 'desova/SET_DETALHES_VOLUME',
    SET_INFORMACOES_SISCOMEX: 'desova/SET_INFORMACOES_SISCOMEX',
    SET_FINALIZAR_DESOVA: 'desova/SET_FINALIZAR_DESOVA',
    SET_CHECKLIST_PEACAO: 'desova/SET_CHECKLIST_PEACAO',
    SET_ITENS_CHECKLIST_PEACAO: 'desova/SET_ITENS_CHECKLIST_PEACAO',
    SET_EXPANDED: 'desova/SET_EXPANDED',
    RESET_DESOVA: 'desova/RESET_DESOVA',
    RESET_DESOVA_LOTE_DIFERENTE: 'desova/RESET_DESOVA_LOTE_DIFERENTE',
    SET_COMBOS_AVARIAS: "desova/SET_COMBOS_AVARIAS",
    SET_AVARIAS: "desova/SET_AVARIAS",
    REMOVE_AVARIAS: "desova/REMOVE_AVARIAS",
    AVARIA_LOCAL_CHECKED: "desova/AVARIA_LOCAL_CHECKED",
    AVARIA_TIPO_CHECKED: "desova/AVARIA_TIPO_CHECKED",
    AVARIA_COMPLEMENTO_CHECKED: "desova/AVARIA_COMPLEMENTO_CHECKED",
    AVARIA_PROVIDENCIA_CHECKED: "desova/AVARIA_PROVIDENCIA_CHECKED",
    AVARIA_PESO: "desova/AVARIA_PESO",
    AVARIA_REMOVER_CHECKED: "desova/AVARIA_REMOVER_CHECKED",
    RESET_AVARIAS: "desova/RESET_AVARIAS",
    RESET_ACRESCIMO: 'desova/RESET_ACRESCIMO',
    RESET_FINALIZAR_DESOVA: 'desova/RESET_FINALIZAR_DESOVA',
    SET_CARACTERISTICAS_CACHE: 'desova/SET_CARACTERISTICAS_CACHE',
    RESET_CARACTERISTICAS_CACHE: 'desova/RESET_CARACTERISTICAS_CACHE'
}

const INITIAL = {
    passagemId: 0,
    loteId: 0,
    listaLotes: [],
    volumeSemReconhecimento: 0,
    reconhecimento: false,
    loteAlteracao: undefined,
    container: '',
    blId: 0,
    motivoInterrupcao: -1,
    title: '',
    titleDescription: '',
    lacre: '',
    empilhadeiras: [],
    embalagens: [],
    localidades: [],
    detalhesVolume: [],
    expanded: [],
    caracteristicasCache: [],
    desova: {
        etiqueta: '',
        volume: '',
        tipo: 0,
        contraMarca: '',
        tipoOperacao: undefined,
        quantidadeRegular: undefined,
        embalagemRegular: -1,
        descricaoEmbalagemRegular: '',
        embalagem: -1,
        descricaoEmbalagem: '',
        empilhadeira: -1,
        altura: undefined,
        largura: undefined,
        comprimento: undefined,
        peso: undefined,
        tipoTemperatura: 0,
        tempMin: undefined,
        tempMax: undefined,
        onu: '',
        labelLocal: '',
        localidades: [],
        localizacao: 0,
        descricaoLocalidade: '',
        localidadePaiId: 0,
        localidadeObjeto: {}
    },
    informacoesSiscomex: {
        Descricao: '',
        DescricaoSiscomex: '',
        Exportador: '',
        Importador: '',
        Marca: '',
        Mensagem: '',
        Shipper: '',
        Sucesso: false
    },
    acrescimo: {
        qtde: null,
        descricao: '',
        embalagem: -1,
        marca: '',
        onu: '',
        peso: null
    },
    finalizarDesova: {
        condicaoContainer: 1,
        tipoOperacao: undefined,
        lacreMarimex: '',
        vistoriaFina: -1,
        ajudantes: [],
        listaAjudantes: [],
        divergencias: '',
        observacao: ''
    },
    itensCheckListPeacao: [],
    checkListPeacao: [],

    TiposAvaria: [],
    LocaisAvaria: [],
    ComplementosAvaria: [],
    ProvidenciasAvaria: [],
    Avarias: [],
    avariaLocalChecked: [],
    avariaTipoChecked: [],
    avariaComplementoChecked: [],
    avariaProvidenciaChecked: [],
    avariaRemoverChecked: [],
    avariaPeso: 0
}

export default function desovaReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesDesova.SET_PASSAGEM_ID:
            return {
                ...state,
                passagemId: action.payload
            };
        case TypesDesova.SET_LOTE_ID:
            return {
                ...state,
                loteId: action.payload
            }
        case TypesDesova.SET_LISTA_LOTES:
            return {
                ...state,
                listaLotes: action.payload
            }
        case TypesDesova.SET_VOLUME:
            return {
                ...state,
                volume: action.payload
            }
        case TypesDesova.SET_VOLUME_SEM_RECONHECIMENTO:
            return {
                ...state,
                volumeSemReconhecimento: action.payload
            }
        case TypesDesova.SET_RECONHECIMENTO:
            return {
                ...state,
                reconhecimento: action.payload
            }
        case TypesDesova.SET_LOTE_ALTERACAO:
            return {
                ...state,
                loteAlteracao: action.payload
            }
        case TypesDesova.SET_CONTAINER:
            return {
                ...state,
                container: action.payload
            };
        case TypesDesova.SET_BL_ID:
            return {
                ...state,
                blId: action.payload
            }
        case TypesDesova.SET_MOTIVO_INTERRUPCAO:
            return {
                ...state,
                motivoInterrupcao: action.payload
            }
        case TypesDesova.SET_TITLE:
            return {
                ...state,
                title: action.payload
            }
        case TypesDesova.SET_TITLE_DESCRIPTION:
            return {
                ...state,
                titleDescription: action.payload
            }
        case TypesDesova.SET_LACRE:
            return {
                ...state,
                lacre: action.payload
            }
        case TypesDesova.SET_EMPILHADEIRAS:
            return {
                ...state,
                empilhadeiras: action.payload
            }
        case TypesDesova.SET_EMBALAGENS:
            return {
                ...state,
                embalagens: action.payload
            }
        case TypesDesova.SET_LOCALIDADES:
            return {
                ...state,
                localidades: action.payload
            }
        case TypesDesova.SET_DESOVA:
            let desovaNew = {};

            Object.assign(desovaNew, state.desova);

            desovaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                desova: desovaNew
            }
        case TypesDesova.SET_ACRESCIMO:
            let acrescimoNew = {};

            Object.assign(acrescimoNew, state.acrescimo);

            acrescimoNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                acrescimo: acrescimoNew
            }
        case TypesDesova.SET_FINALIZAR_DESOVA:
            let finalizarDesovaNew = {};

            Object.assign(finalizarDesovaNew, state.finalizarDesova);

            finalizarDesovaNew[action.payload.campo] = action.payload.valor

            return {
                ...state,
                finalizarDesova: finalizarDesovaNew
            }
        case TypesDesova.SET_ITENS_CHECKLIST_PEACAO:
            return {
                ...state,
                itensCheckListPeacao: action.payload.itensCheckListPeacao
            };
        case TypesDesova.SET_CHECKLIST_PEACAO:
            let objCheckListPeacao = state.checkListPeacao.slice();
            let item = {};

            if (action.payload.obj.Valor < 0)
                return {
                    ...state
                };

            if (state.checkListPeacao.length > 0) {

                item = objCheckListPeacao.find((element) =>
                    element.Id === action.payload.obj.Id
                );

                if (item !== undefined)
                    item.Valor = action.payload.obj.Valor;
                else
                    objCheckListPeacao.push(action.payload.obj);

            }

            if (state.checkListPeacao.length <= 0)
                objCheckListPeacao.push(action.payload.obj);

            return {
                ...state,
                checkListPeacao: JSON.stringify(action.payload.obj).at(0) === '{' ? objCheckListPeacao : action.payload.obj
            };
        case TypesDesova.SET_DETALHES_VOLUME:
            return {
                ...state,
                detalhesVolume: action.payload
            }
        case TypesDesova.SET_INFORMACOES_SISCOMEX:
            return {
                ...state,
                informacoesSiscomex: action.payload
            }
        case TypesDesova.SET_EXPANDED:
            return {
                ...state,
                expanded: action.payload
            }
        case TypesDesova.RESET_DESOVA:

            let resetDesova = {};

            Object.assign(resetDesova, state.desova);

            resetDesova.volume = '';
            resetDesova.etiqueta = '';
            resetDesova.tipoOperacao = -1;
            resetDesova.onu = '';
            resetDesova.contraMarca = '';

            return {
                ...state,
                volumeSemReconhecimento: 0,
                desova: resetDesova
            };
        case TypesDesova.RESET_DESOVA_LOTE_DIFERENTE:
            let resetDesovaLoteDiferente = {};

            Object.assign(resetDesovaLoteDiferente, state.desova);

            resetDesovaLoteDiferente.tipo = 0;
            resetDesovaLoteDiferente.embalagem = -1;
            resetDesovaLoteDiferente.altura = undefined;
            resetDesovaLoteDiferente.largura = undefined;
            resetDesovaLoteDiferente.comprimento = undefined;
            resetDesovaLoteDiferente.peso = undefined;
            resetDesovaLoteDiferente.labelLocal = '';
            resetDesovaLoteDiferente.localidades = [];
            resetDesovaLoteDiferente.localizacao = 0;
            resetDesovaLoteDiferente.descricaoLocalidade = '';
            resetDesovaLoteDiferente.localidadePaiId = 0;
            resetDesovaLoteDiferente.localidadeObjeto = {};

            return {
                ...state,
                desova: resetDesovaLoteDiferente
            };
        case TypesDesova.SET_COMBOS_AVARIAS:
            return {
                ...state,
                TiposAvaria: action.payload.Tipos,
                LocaisAvaria: action.payload.Locais,
                ComplementosAvaria: action.payload.Complementos,
                ProvidenciasAvaria: action.payload.Providencias
            };
        case TypesDesova.SET_AVARIAS:
            return {
                ...state,
                Avarias: action.payload
            };
        case TypesDesova.AVARIA_LOCAL_CHECKED:
            return {
                ...state,
                avariaLocalChecked: action.payload
            };
        case TypesDesova.AVARIA_TIPO_CHECKED:
            return {
                ...state,
                avariaTipoChecked: action.payload
            };
        case TypesDesova.AVARIA_COMPLEMENTO_CHECKED:
            return {
                ...state,
                avariaComplementoChecked: action.payload
            };
        case TypesDesova.AVARIA_PROVIDENCIA_CHECKED:
            return {
                ...state,
                avariaProvidenciaChecked: action.payload
            }
        case TypesDesova.AVARIA_PESO:
            return {
                ...state,
                avariaPeso: action.payload
            }
        case TypesDesova.AVARIA_REMOVER_CHECKED:
            return {
                ...state,
                avariaRemoverChecked: action.payload
            };
        case TypesDesova.REMOVE_AVARIAS:
            return ({
                ...state,
                Avarias: [...state.Avarias.filter(function (a, index) { return !state.avariaRemoverChecked.includes(index) })]
            })
        case TypesDesova.RESET_AVARIAS:
            return {
                ...state,
                TiposAvaria: [],
                LocaisAvaria: [],
                ComplementosAvaria: [],
                ProvidenciasAvaria: [],
                Avarias: [],
                avariaLocalChecked: [],
                avariaTipoChecked: [],
                avariaComplementoChecked: [],
                avariaProvidenciaChecked: [],
                avariaRemoverChecked: [],
                avariaPeso: 0
            }
        case TypesDesova.RESET_ACRESCIMO:
            return {
                ...state,
                acrescimo: INITIAL.acrescimo
            }
        case TypesDesova.RESET_FINALIZAR_DESOVA:
            return {
                ...state,
                finalizarDesova: INITIAL.finalizarDesova
            }
        case TypesDesova.SET_CARACTERISTICAS_CACHE:
            let mapCaracteristicas = new Map(state.caracteristicasCache.map((item) => [item.loteId, item.detalhes]));

            mapCaracteristicas.set(action.payload.lote, action.payload.caracteristicas);

            let mapToArray = Array.from(mapCaracteristicas, ([loteId, detalhes]) => ({
                loteId,
                detalhes
            }));

            return {
                ...state,
                caracteristicasCache: mapToArray
            }
        case TypesDesova.RESET_CARACTERISTICAS_CACHE:
            return {
                ...state,
                caracteristicasCache: INITIAL.caracteristicasCache
            }
        default:
            return state;
    }
}

export const DesovaActions = {
    setPassagemId,
    setLoteId,
    setListaLotes,
    setVolume,
    setVolumeSemReconhecimento,
    setReconhecimento,
    setLoteAlteracao,
    setContainer,
    setBlId,
    setMotivoInterrupcao,
    setTitle,
    setTitleDescription,
    setLacre,
    setEmpilhadeiras,
    setEmbalagens,
    setLocalidades,
    setDesova,
    setAcrescimo,
    setFinalizarDesova,
    setItensCheckListPeacao,
    setCheckListPeacao,
    setDetalhesVolume,
    setInformacoesSiscomex,
    setExpanded,
    resetDesova,
    resetDesovaLoteDiferente,
    setCombosAvarias,
    setAvarias,
    deletarAvarias,
    avariaLocalChecked,
    avariaTipoChecked,
    avariaComplementoChecked,
    avariaProvidenciaChecked,
    avariaPeso,
    avariaRemoverChecked,
    resetAvarias,
    resetAcrescimo,
    resetFinalizarDesova,
    setCaracteristicasCache,
    resetCaracteristicasCache
}

function setPassagemId(id) {
    return {
        type: TypesDesova.SET_PASSAGEM_ID,
        payload: id
    }
}

function setLoteId(id) {
    return {
        type: TypesDesova.SET_LOTE_ID,
        payload: id
    }
}

function setListaLotes(listaLotes) {
    return {
        type: TypesDesova.SET_LISTA_LOTES,
        payload: listaLotes
    }
}

function setVolume(volume) {
    return {
        type: TypesDesova.SET_VOLUME,
        payload: volume
    }
}

function setVolumeSemReconhecimento(volumeSemReconhecimento) {
    return {
        type: TypesDesova.SET_VOLUME_SEM_RECONHECIMENTO,
        payload: volumeSemReconhecimento
    }
}

function setReconhecimento(reconhecimento) {
    return {
        type: TypesDesova.SET_RECONHECIMENTO,
        payload: reconhecimento
    }
}

function setLoteAlteracao(lote) {
    return {
        type: TypesDesova.SET_LOTE_ALTERACAO,
        payload: lote
    }
}

function setContainer(container) {
    return {
        type: TypesDesova.SET_CONTAINER,
        payload: container
    }
}

function setBlId(blId) {
    return {
        type: TypesDesova.SET_BL_ID,
        payload: blId
    }
}

function setMotivoInterrupcao(motivo) {
    return {
        type: TypesDesova.SET_MOTIVO_INTERRUPCAO,
        payload: motivo
    }
}

function setTitle(title) {
    return {
        type: TypesDesova.SET_TITLE,
        payload: title
    }
}

function setTitleDescription(titleDescription) {
    return {
        type: TypesDesova.SET_TITLE_DESCRIPTION,
        payload: titleDescription
    }
}

function setLacre(lacre) {
    return {
        type: TypesDesova.SET_LACRE,
        payload: lacre
    }
}

function setEmpilhadeiras(empilhadeiras) {
    return {
        type: TypesDesova.SET_EMPILHADEIRAS,
        payload: empilhadeiras
    }
}

function setEmbalagens(embalagens) {
    return {
        type: TypesDesova.SET_EMBALAGENS,
        payload: embalagens
    }
}

function setLocalidades(localidades) {
    return {
        type: TypesDesova.SET_LOCALIDADES,
        payload: localidades
    }
}

function setDesova(valor, campo) {
    return {
        type: TypesDesova.SET_DESOVA,
        payload: { valor: valor, campo: campo }
    }
}

function setAcrescimo(valor, campo) {
    return {
        type: TypesDesova.SET_ACRESCIMO,
        payload: { valor: valor, campo: campo }
    }
}

function setFinalizarDesova(valor, campo) {
    return {
        type: TypesDesova.SET_FINALIZAR_DESOVA,
        payload: { valor: valor, campo: campo }
    }
}

function setCheckListPeacao(obj) {
    return {
        type: TypesDesova.SET_CHECKLIST_PEACAO,
        payload: { obj: obj }
    }
}

function setItensCheckListPeacao(itensCheckListPeacao) {
    return {
        type: TypesDesova.SET_ITENS_CHECKLIST_PEACAO,
        payload: { itensCheckListPeacao: itensCheckListPeacao }
    }
}

function setDetalhesVolume(detalhesVolume) {
    return {
        type: TypesDesova.SET_DETALHES_VOLUME,
        payload: detalhesVolume
    }
}

function setInformacoesSiscomex(informacoesSiscomex) {
    return {
        type: TypesDesova.SET_INFORMACOES_SISCOMEX,
        payload: informacoesSiscomex
    }
}

function setExpanded(expanded) {
    return {
        type: TypesDesova.SET_EXPANDED,
        payload: expanded
    }
}

function resetDesova() {
    return {
        type: TypesDesova.RESET_DESOVA
    }
}

function resetDesovaLoteDiferente() {
    return {
        type: TypesDesova.RESET_DESOVA_LOTE_DIFERENTE
    }
}

function resetAcrescimo() {
    return {
        type: TypesDesova.RESET_ACRESCIMO
    }
}

function setCombosAvarias(dadosAvarias) {
    return {
        type: TypesDesova.SET_COMBOS_AVARIAS,
        payload: dadosAvarias
    }
}

function avariaLocalChecked(checked) {
    return {
        type: TypesDesova.AVARIA_LOCAL_CHECKED,
        payload: checked
    }
}

function avariaTipoChecked(checked) {
    return {
        type: TypesDesova.AVARIA_TIPO_CHECKED,
        payload: checked
    }
}

function avariaComplementoChecked(checked) {
    return {
        type: TypesDesova.AVARIA_COMPLEMENTO_CHECKED,
        payload: checked
    }
}

function avariaProvidenciaChecked(checked) {
    return {
        type: TypesDesova.AVARIA_PROVIDENCIA_CHECKED,
        payload: checked
    }
}

function avariaPeso(peso) {
    return {
        type: TypesDesova.AVARIA_PESO,
        payload: peso
    }
}

function avariaRemoverChecked(checked) {
    return {
        type: TypesDesova.AVARIA_REMOVER_CHECKED,
        payload: checked
    }
}

function setAvarias(dadosAvarias) {
    return {
        type: TypesDesova.SET_AVARIAS,
        payload: dadosAvarias
    }
}

function deletarAvarias(avaria) {
    return {
        type: TypesDesova.REMOVE_AVARIAS
    }
}

function resetAvarias() {
    return {
        type: TypesDesova.RESET_AVARIAS
    }
}

function resetFinalizarDesova() {
    return {
        type: TypesDesova.RESET_FINALIZAR_DESOVA
    }
}

function setCaracteristicasCache(lote, caracteristicas) {
    return {
        type: TypesDesova.SET_CARACTERISTICAS_CACHE,
        payload: { lote: lote, caracteristicas: caracteristicas }
    }
}

function resetCaracteristicasCache() {
    return {
        type: TypesDesova.RESET_CARACTERISTICAS_CACHE
    }
}